import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ErrorComponent } from "./error/error.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { LoginComponent } from "./login/login.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { AccountActivationComponent } from "./account-activation/account-activation.component";

const routes: Routes = [
	{
		path: "",
		children: [
			{
				path: "",
				component: LoginComponent
			},
			{
				path: "carsome",
				component: LoginComponent
			},
			{
				path: "mg",
				component: LoginComponent
			},
			{
				path: "imotorbike",
				component: LoginComponent
			},
			{
				path: "login",
				component: LoginComponent
			},
			{
				path: "forgot-password",
				component: ForgotPasswordComponent
			},
			{
				path: "forgot-password/change",
				component: ResetPasswordComponent
			},
			{
				path: "account-activation",
				component: AccountActivationComponent
			},
			{
				path: "404",
				component: ErrorComponent
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class AuthenticationRoutingModule {}
